import { render, staticRenderFns } from "./LinkApplication.vue?vue&type=template&id=0c2271c8"
import script from "./LinkApplication.vue?vue&type=script&lang=js"
export * from "./LinkApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports